import React, { useState } from 'react';

import Accordion from '@mui/material/Accordion';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import { _faqs } from 'src/_mock';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function FaqsList() {
  const [expandedId, setExpandedId] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpandedId(isExpanded ? panel : null);
  };
  return (
    <div>
      {_faqs.map((accordion) => (
        <Accordion
          key={accordion.id}
          onChange={handleChange(accordion.id)}
          expanded={expandedId === accordion.id}
        >
          <AccordionSummary expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}>
            <Typography
              variant="subtitle1"
              sx={{ color: expandedId === accordion.id ? 'primary.main' : 'inherit' }}
            >
              {accordion.heading}
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Typography>{accordion.detail}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
